import React from 'react';
import { isEmpty, cloneDeep, filter } from 'lodash';

import { moveAndPushDown } from '../../common/collection';

import ACCategory from '../../atoms/ACCategory';
import POICategory from './POICategory';

const dummyCategoryName = 'Unsorted';
const addNewCategorylabel = 'Add new category';
export default class POIs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: -1,
    };
    this.onUpdateCategoryName = this.onUpdateCategoryName.bind(this);
    this.onAddNewCategory = this.onAddNewCategory.bind(this);

    this.highlightDestination = this.highlightDestination.bind(this);
    this.onSwapComplete = this.onSwapComplete.bind(this);
  }

  highlightDestination(poiIndex) {
    this.setState({
      highlight: poiIndex,
    });
  }

  onSwapComplete(from, to) {
    this.setState({ highlight: -1 });
    const { pois } = cloneDeep(this.props);

    // Exchange the categories as well.
    const fromCategory = pois[from].category || '';
    const toCategory = pois[to].category || '';

    if (fromCategory !== toCategory) {
      alert('Swap can only proceed within categories');
      return;
    }

    const fromInt = parseInt(from.toString());
    const toInt = parseInt(to.toString());
    this.props.onSavePOIsFunc(moveAndPushDown(pois, fromInt, toInt));
  }

  onUpdateCategoryName(fromName, toName) {
    const { pois, dummyCategoryName = '' } = cloneDeep(this.props);

    // Check if the POIs are not categorized. If so, just put all the ones against new category.
    if (fromName.toUpperCase() === dummyCategoryName.toUpperCase()) {
      const updatedPOIs = cloneDeep(
        filter(pois, poi => {
          if (isEmpty(poi.category)) {
            return (poi.category = toName);
          } else return poi;
        })
      );

      this.props.onSavePOIsFunc(updatedPOIs);
    } else {
      const updatedPOIs = cloneDeep(
        filter(pois, poi => {
          if (poi.category === fromName) {
            return (poi.category = toName);
          } else return poi;
        })
      );
      this.props.onSavePOIsFunc(updatedPOIs);
    }
  }

  onAddNewCategory(toName) {
    if (toName === addNewCategorylabel || isEmpty(toName)) return null;

    const { pois } = cloneDeep(this.props);
    const poi = {
      category: toName,
      name: 'New place name for ' + toName,
      where: {
        address: undefined,
      },
    };
    pois.push(poi);
    this.props.onSavePOIsFunc(pois);
  }

  renderAddNewCategory() {
    return (
      <ACCategory
        key={[this.props.providerId, 'new-category'].join('_')}
        label={addNewCategorylabel}
        onUpdateTextFunc={(from, to) => this.onAddNewCategory(to)}
      />
    );
  }

  renderPOICategories(pois) {
    if (isEmpty(pois)) return <div />;
    const { categories = [] } = cloneDeep(this.props);

    // Attach an order to help with swapping.
    pois.forEach((poi, index) => {
      poi.index = index;
    });

    return categories.map(category => {
      let filteredPOIs = [];
      if (category === dummyCategoryName) {
        filteredPOIs = cloneDeep(
          filter(pois, poi => {
            return isEmpty(poi.category)||poi.category===dummyCategoryName;
          })
        );
      } else {
        filteredPOIs = cloneDeep(filter(pois, { category: category }));
      }

      return (
        <POICategory
          category={category}
          pois={filteredPOIs}
          onUpdateCategoryNameFunc={this.onUpdateCategoryName}
          onSwapPOIsFunc={this.onSwapComplete}
          highlightDestinationFunc={this.highlightDestination}
          highlight={this.state.highlight}
          onClickPOIFunc={this.props.onClickPOIFunc}
          showCategory={this.props.showCategory}
          onDeletePOIFunc={this.props.onDeletePOIFunc}
        />
      );
    });
  }

  render() {
    const { pois } = this.props;
    return (
      <div>
        {this.renderPOICategories(pois)}
        {this.props.showCategory && this.renderAddNewCategory()}
      </div>
    );
  }
}
